import React from 'react';

function NotFound() {
    return (
        <h1 style={{textAlign: 'center'}}>Sorry, page not found.</h1>
    );
}

export default NotFound;
